// 150フォルダ内画像一括import
export const thumbnail150 = {
  "01": require("./01_thumbnail.png"),
  "02": require("./02_thumbnail.png"),
  "03": require("./03_thumbnail.png"),
};

export const image150 = {
  "01": require("./01.png"),
  "02": require("./02.png"),
  "03": require("./03.png"),
};
